module.exports = __webpack_public_path__ + "static/media/header-network-bscModal.90c531fc.svg";